import React from "react";
import ImgLazyLoad from "./ImgLazyLoad";

interface Props {
  title: string;
  id: string;
  isCollapsed?: boolean;
  icon?: string;
  disclaimer?: string;
}

class ArrowCollapsible extends React.Component<Props> {
  constructor(props) {
    super(props);
  }

  render() {
    const { title, id, isCollapsed, children, icon, disclaimer } = this.props;
    return (
      <div className="generic-arrow-accordion container">
        <div className="panel panel-default">
          <div className="panel-heading" role="tab">
            <h4 className="panel-title">
              <a
                data-toggle="collapse"
                href={"#" + id}
                aria-expanded={isCollapsed ? "false" : "true"}
                aria-controls={id}
                className={isCollapsed ? "collapsed" : ""}
              >
                <div className={icon ? "panel-heading-icon" : "hidden"}>
                  <ImgLazyLoad src={icon} />
                </div>
                <span>{title}</span>
              </a>
              {disclaimer && (
                <span className="tt">
                  *<span className="tt__content">{disclaimer}</span>
                </span>
              )}
            </h4>
          </div>
          <div id={id} className={isCollapsed ? "collapse" : "collapse in"}>
            {children}
          </div>
        </div>
      </div>
    );
  }
}

export default ArrowCollapsible;
